webpackJsonp([140933230050240],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/posts.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"site": {
				"siteMetadata": {
					"title": "Nate A Taylor",
					"author": "Nate A Taylor",
					"description": "Website of Nate A Taylor"
				}
			},
			"allMarkdownRemark": {
				"edges": [
					{
						"node": {
							"fields": {
								"slug": "/posts/2017/08/02/building-a-blog-with-gatsby-pt-2/"
							},
							"frontmatter": {
								"title": "Building a Blog with Gatsby Pt 2",
								"summary": "Setup Gatsby to automatically turn markdown files into blog posts.",
								"date": "August 02, 2017"
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/posts/2017/07/21/building-a-blog-with-gatsby-pt-1/"
							},
							"frontmatter": {
								"title": "Building a Blog with Gatsby Pt 1",
								"summary": "How to build a personal site with Gatsby.",
								"date": "July 21, 2017"
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/posts/2017/07/18/welcome/"
							},
							"frontmatter": {
								"title": "Welcome",
								"summary": "An introduction to me.",
								"date": "July 18, 2017"
							}
						}
					}
				]
			}
		},
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---posts-9037fd046ab9f1ee6ddd.js